// react
import React, { Component, PropTypes } from "react"
import { connect } from "react-redux"
//material-ui
import MUIAutoComplete from "material-ui/AutoComplete"
// app
import { list } from "actions/ref/actions.js"


class AutoComplete extends Component {
    constructor(props) {
        super()

        this.state = {
            errorText: "",
            text: "",
            dataSource: this.getDataSource(props.reference)
        }

        this.onChange = value => {
            if (this.props.mandatory && value === "") {
                this.setState({ errorText: "This field is required" })
                if (this.props.onError) this.props.onError(true)
                return false
            }

            if (this.state.dataSource.indexOf(value) === -1) {
                if (!this.props.extensible) {
                    this.setState({ errorText: "Please select an existing value" })
                    if (this.props.onError) this.props.onError(true)
                    return false
                }
            } 
            
            this.setState({
                errorText: "",
                text: value,
                new: this.state.dataSource.indexOf(value) === -1
            })

            if (this.props.onError) this.props.onError(false)
            if (this.props.onChange) this.props.onChange(value)
        }
    }

    componentDidMount() {
        if (!this.props.reference) this.props.list()

        if (!this.props.value && this.props.mandatory)
            if (this.props.onError) this.props.onError(true)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ dataSource: this.getDataSource(nextProps.reference) })
    }

    getDataSource(reference) {
        const dataSource = []

        if (reference)
            if (reference.has("data"))
                reference.get("data").forEach(item => {
                    dataSource.push(item.text)
                })

        return dataSource
    }

    render() {
        const label = this.props.label + ((this.props.mandatory) ? ("*") : (""))
        const hintText = this.props.extensible ?
            `Please select or enter your ${ this.props.table }`
            :
            `Please select a ${ this.props.table }`
        const searchText = this.state.dataSource.indexOf(this.props.value) === -1 ?
            "" : this.props.value
        
        return (
            <MUIAutoComplete
                filter={ MUIAutoComplete.caseInsensitiveFilter }
                dataSource={ this.state.dataSource }
                searchText={ searchText }
                floatingLabelText={ label }
                hintText={ hintText }
                errorText={ this.state.errorText }
                onNewRequest={ this.onChange }
                onUpdateInput={ this.onChange }
                fullWidth={ true }
                maxLength={ this.props.maxLength || 255 }
                maxSearchResults={ this.props.maxSearchResults || 10 }
                openOnFocus={ true }
            />
        )
    }
}

AutoComplete.propTypes = {
    extensible: PropTypes.bool,
    label: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
    mandatory: PropTypes.bool,
    maxLength: PropTypes.number,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onError: PropTypes.func
}

const mapStateToProps = (state, ownProps) => {
    return {
        reference: state.ref.get(ownProps.table)
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        list: () => dispatch(list(ownProps.table))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AutoComplete)


/** WEBPACK FOOTER **
 ** ./src/containers/AutoComplete/autocomplete.js
 **/